<template>
    <tr style="height: 110px;" v-if="width > 767">
        <th>
            <div class="d-flex justify-content-between position-relative">
                <span class="mt-1">{{ columnName }}</span>
            </div>
        </th>
        <td>
            <input class="rounded border" size="110" v-model="address"/>
        </td>
    </tr>
    <div v-else>
        <div class="d-flex justify-content-between position-relative p-3 rounded" style="background: #FAF4EC; ">
            <span class="mt-1 sp-input-column">{{ columnName }}</span>
        </div>
        <input class="rounded border sp-input" v-model="address" />
    </div>
</template>

<script>
export default ({
    props: {
        columnName: String,
    },
    data() {
        return {
            width: this.$store.state.width,
        }
    },
    mounted: function () {
        window.addEventListener('resize', this.headlineResize)
    },
    methods: {
        headlineResize() {
            this.width = window.outerWidth;
        },
    },
    computed: {
        address: {
            set(v) {
                this.$store.commit('updateAddress', v)
            },
            get() {
                return this.$store.state.address
            }
        },
    },

})
</script>
